import type { NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw } from 'vue-router';

import { ApiError } from '@/core/lib/ApiUtils';
import { isOffreRubriqueCode } from '@/core/lib/OffreUtils';
import { AccessDeniedRouteError, convertMaybeErrorToRouteError } from '@/core/lib/RouterUtils';
import { RouteName } from '@/core/router/RouteName';
import { getComparateurEmprunteurUrl } from '@/domains/offres/lib/OffreApi';

const routes: readonly RouteRecordRaw[] = [
  {
    name: RouteName.OFFRES,
    path: '/offres/rubrique/:rubriqueCode',
    component: () => import('@/domains/offres/views/OffresPage.vue'),
    props: true,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
      const { rubriqueCode } = to.params;

      if (!isOffreRubriqueCode(rubriqueCode)) {
        next({ name: RouteName.ERROR_NOT_FOUND });

        return;
      }

      next();
    },
  },
  {
    name: RouteName.OFFRES_COMPARATEUR_EMPRUNTEUR,
    path: '/offres/comparateur/emprunteur',
    component: () => import('@/views/LoadingPage.vue'),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      try {
        window.location.href = await getComparateurEmprunteurUrl();

        next();
      } catch (e) {
        // If the user is not found or have not enough privileges
        if (e instanceof ApiError && [400, 401, 403, 404].includes(e.statusCode)) {
          next(new AccessDeniedRouteError(e.message));

          return;
        }

        next(convertMaybeErrorToRouteError(e));

        return;
      }
    },
  },
];

export default routes;
